export default "__VITE_ASSET___qPOLRlz__"